module.exports = __webpack_public_path__ + "img/yqc3.1608bf77.jpg";